import React, { useState, useEffect } from 'react';
import CashImg from '../../images/Cash in hand_2.png';
import HomeImg from '../../images/Stay at home.png';
import KeyImg from '../../images/Key.png';
import DocumentImg from '../../images/Documents.png';

const CampaignIncomeChart = props => (
  <div div className="CampaignDonutChart">
    <h2>{props.title}</h2>
    <div className="CampaignBarChart_more-info" onClick={()=>props.closeModal(true)}>More info</div>

    <div className="CampaignIncomeChart_container">

      <div className="CampaignIncomeChart_content-block" >
        <div className="CampaignIncomeChart_image" style={ props.title === 'Income' ? {background: '#FF856D'} : {background: '#EDEEF8'}}>
          <img src={props.title === 'Income' ? CashImg : DocumentImg }/>
        </div>
        <div className="CampaignIncomeChart_title">
          { props.title === 'Income' ? `Average Personal Income`  : `Average Monthly Mortgage` }
        </div>
        <div className="CampaignIncomeChart_dolor-value">
         { props.title === 'Income' ? `$54,191`  : `$3,447` }
        </div>
      </div>

      <div className="CampaignIncomeChart_content-block">
        <div className="CampaignIncomeChart_image"  style={ props.title === 'Income' ? {background: '#FF856D'} : {background: '#EDEEF8'}}>
        <img src={props.title === 'Income' ? HomeImg : KeyImg }/>
        </div>
        <div className="CampaignIncomeChart_title">
        { props.title === 'Income' ? `Average Household Income`  : `Average Monthly Rent` }
        </div>
        <div className="CampaignIncomeChart_dolor-value">
          { props.title === 'Income' ? `$123,317`  : `$1,500` }
        </div>
      </div>

    </div>

    <div className="CampaignIncomeChart_bottom-text">[Media Owner] Average is yyyyy'.</div>
  </div>
);

export default CampaignIncomeChart;
